import { RequiredActionTypeOutput } from '../types';
import { NoShowRequiredAction } from './no-show-required-action';
import { ARAgentConfirmationRequiredAction } from './appointment-reminder/ar-agent-confirmation-required-action';
import { ArAgentRescheduleRequiredAction } from './appointment-reminder/ar-agent-reschedule-required-action';
import { ArCsrAgentRunningLateRequiredAction } from './appointment-reminder/ar-csr-agent-running-late-required-action';
import {
  ArCsrAcknowledgedAgentWillBeLateRequiredAction
} from './appointment-reminder/ar-csr-acknowledged-agent-late-required-action';
import { ArCsrRescheduleRequiredAction } from './appointment-reminder/ar-csr-reschedule-required-action';
import {
  ArAgentAppointmentRescheduledRequiredAction
} from './appointment-reminder/ar-agent-appointment-rescheduled-required-action';
import { ArAgentReassignedRequiredAction } from './appointment-reminder/ar-agent-reassigned-required-action';
import { ArCsrReassignRequiredAction } from './appointment-reminder/ar-csr-reassign-required-action';
import { ArCsr5MinsRequiredAction } from './appointment-reminder/ar-csr-5-mins-required-action';

export const actionTypeMap = {
  [RequiredActionTypeOutput.ActionRequiredSetNoShow]: NoShowRequiredAction,
  [RequiredActionTypeOutput.AppointmentReminderRequiredAgentConfirmation]: ARAgentConfirmationRequiredAction,
  [RequiredActionTypeOutput.AppointmentReminderSuggestedToRescheduleAppointmentByAgentRequiredAgentAction]: ArAgentRescheduleRequiredAction,
  [RequiredActionTypeOutput.AppointmentReminderAppointmentIsRescheduledOnAnotherTimeRequiredAgentAction]: ArAgentAppointmentRescheduledRequiredAction,
  [RequiredActionTypeOutput.AppointmentReminderCsrAcknowledgedAgentWillBeLateRequiredAgentAction]: ArCsrAcknowledgedAgentWillBeLateRequiredAction,

  [RequiredActionTypeOutput.AppointmentReminderCreatedNewAppointmentWithAnotherAgentRequiredAgentAction]: ArAgentReassignedRequiredAction,
  [RequiredActionTypeOutput.AppointmentReminderAgentConfirmedButWillBeLateRequiredCsrAction]: ArCsrAgentRunningLateRequiredAction,
  [RequiredActionTypeOutput.AppointmentReminderRequiredRescheduleOnAnotherTimeRequiredCsrAction]: ArCsrRescheduleRequiredAction,
  [RequiredActionTypeOutput.AppointmentReminderRequiredRescheduleOnAnotherAgentRequiredCsrAction]: ArCsrReassignRequiredAction,
  [RequiredActionTypeOutput.AppointmentReminderAgentHas5MinBeforeAppointmentRequiredCsrAction]: ArCsr5MinsRequiredAction,
}
